// Relative path: src/components/Popup/DetailsPopup.js

import React from 'react';
import Popup from './Popup';

/**
 * Generic details popup component for displaying a title and multiple paragraphs
 * 
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the popup is open
 * @param {Function} props.onClose - Function to call when popup is closed
 * @param {string} props.title - The title to display at the top of the popup
 * @param {Array} props.paragraphs - Array of paragraph texts to display
 */
const DetailsPopup = ({ isOpen, onClose, title, paragraphs = [] }) => {
  return (
    <Popup isOpen={isOpen} onClose={onClose}>
      <div className="py-8 px-6">
        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-2">
          {title}
        </h2>
        
        {/* Paragraphs */}
        <div className="space-y-4">
          {paragraphs.map((paragraph, index) => (
            paragraph ? (
              <p key={index} className="text-gray-700 leading-relaxed">
                {paragraph}
              </p>
            ) : null
          ))}
        </div>
      </div>
    </Popup>
  );
};

export default DetailsPopup;